/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type TransactionType = 1 | 2 | 3 | 4;

export const TransactionType = {
    NUMBER_1: 1 as TransactionType,
    NUMBER_2: 2 as TransactionType,
    NUMBER_3: 3 as TransactionType,
    NUMBER_4: 4 as TransactionType
};